<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="520px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4">Add Support Agent</v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="name"
              label="Name"
              variant="outlined"
              density="compact"
              class="mb-2"
              :rules="[(v) => !!String(v || '').trim() || 'Name is required']"
            />
            <v-text-field
              v-model="email"
              label="Email"
              type="email"
              variant="outlined"
              density="compact"
              :rules="[(v) => !!String(v || '').trim() || 'Email is required', (v) => /.+@.+\..+/.test(v) || 'Email must be valid']"
            />
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose">Cancel</v-btn>
          <v-btn
            color="primary"
            variant="flat"
            :disabled="loading"
            :loading="loading"
            @click="handleSubmit"
          >
            Add Agent
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { create_support_agent } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "AddSupportAgentDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "created"],
  data() {
    return {
      valid: false,
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
        name: "",
        email: "",
    
     
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.name = "";
      this.email = "";
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async handleSubmit() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      this.loading = true;
      try {
        const response = await client.graphql({
          query: create_support_agent,
          variables: {
            input: {
              agent_name: this.name,
              agent_email_id: this.email,
            },
          },
        });
        const rawPayload = response.data.create_support_agent;
        const responseData =
          typeof rawPayload === "string"
            ? JSON.parse(rawPayload)
            : rawPayload;
        if (responseData.success === true || responseData.status == "SUCCESS") {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              (typeof responseData.message === "string"
                ? responseData.message
                : "") ||
              "Support agent added successfully",
            color: "success",
          };
          this.$emit("created", 0);
          this.handleClose();
        } else {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              (typeof responseData.message === "string"
                ? responseData.message
                : "") ||
              "Failed to create agent",
            color: "error",
          };
        }
      } catch (error) {
        this.loading = false;
        console.error("Error creating agent:", error);
        this.snackbar = {
          show: true,
          message:
            (typeof error?.message === "string" && error.message) ||
            "Failed to create agent",
          color: "error",
        };
      }
    },
  },
};
</script>

<style scoped></style>
